import { useState, useCallback } from "react"
import PropTypes from "prop-types"
import { Avatar, ListItemAvatar, ListItem, ListItemText, Button } from "@mui/material"
import { CloudDownload } from "@mui/icons-material"
import classNames from "classnames"
import { fileDownload } from "helpers/csv"
import { appendTimestamp } from "modules/server-notifications/helpers"
import { getCurrentToken } from "api/token"
import { useAccountAlias, useUserId } from "resources/account"

export default function ServerLink({ filePath, createdAt }) {
  const [error, setError] = useState(false)
  const account = useAccountAlias()
  const userId = useUserId()

  const securitySearchDownload = useCallback(async () => {
    if (error) { return }
    try {
      const token = await getCurrentToken({ account, userId })
      const response = await fetch(`/api/${encodeURIComponent(account)}/securitySearchDownload`, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-OmegaPoint-Code": token,
        },
        body: JSON.stringify({
          filePath,
        }),
      })

      if (!response.ok) {
        console.error(`securitySearchDownload failed: status ${response.status} for account ${account}`)
        setError(true)
        return
      }
      const data = await response.blob()
      const name = filePath.slice(filePath.lastIndexOf("/") + 1).replace(/\.csv$/i, ".xlsx")
      fileDownload(data, name)
    } catch (err) {
      console.error(`securitySearchDownload threw for account ${account}:`, err)
      setError(true)
    }
  }, [error, filePath, account, userId])

  return <ListItem
    className="success"
    secondaryAction={<Button className={classNames({ error })} color="primary" onClick={() => securitySearchDownload()}>
      {!error ? "Download" : "Error"}
    </Button>}
  >
    <ListItemAvatar>
      <Avatar>
        <CloudDownload />
      </Avatar>
    </ListItemAvatar>
    <ListItemText primary="Your file is ready" secondary={appendTimestamp("Security Search Results", createdAt)} />
  </ListItem>
}

ServerLink.propTypes = {
  filePath: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
}
